class User {
  constructor(userName, password, uniqueId) {
    this.userName = userName;
    this.password = password;
    this.uniqueId = uniqueId;
  }
}
import CryptoJS from 'crypto-js';
export default {
  inject: ['load'],
  data() {
    return {
      userLogin: new User('', ''),
    };
  },
  methods: {
    loadFromLocalStorage_selectStateMission() {
      const saved = localStorage.getItem('selectMissonState');
      if (saved == "true") {
        // this.$router.push({ name: 'newMissionWithMap800' });
        // this.navigateTo('currentMission800');

        this.$router.push({ name: 'newMissionWithMap800' });
        const routeData = this.$router.resolve({
          name: 'currentMission800',
        });
        window.open(routeData.href, '_blank');

        return
      }
      this.$router.push({ name: 'dispatchMap' });
      const routeData = this.$router.resolve({
        name: 'mission800',
      });
      window.open(routeData.href, '_blank');
      // this.$router.push({ name: 'dispatchMap' });
      // this.navigateTo('mission800');
    },
    //users
    loginUser: function () {
      if (!this.userLogin.userName) {
        this.snackText = 'لطفا نام کاربری را وارد نمایید';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.userLogin.password) {
        this.snackText = 'لطفا کلمه عبور را وارد نمایید';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('loginUser', this.userLogin).then(() => {
        if (this.$store.state.loginModule.successFlag) {
          /*if (this.load.val) {
                        this.load.val = false;
                    }*/
          this.$store.dispatch('csrf').then(() => {
            if (this.$store.state.loginModule.successFlag) {
              this.$store.dispatch('getUserCurrent').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  if (this.load.val) {
                    this.load.val = false;
                  }
                  this.userLogin = new User('', '', '');
                  let temp = this.$store.state.userModule.user;

                  if (temp.roles.length === 1) {
                    if (temp.roles[0].englishTitle == 'Admin') {
                      this.userRoleEnglishTitle = temp.roles[0].englishTitle;
                      this.userRoleIdForLogin = temp.roles[0].id;
                      this.$router.push({ name: 'user' });
                      let id = temp.roles[0].id.toString();
                      let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
                      localStorage.setItem('dash', encryptId);
                      this.setTheme('blue');
                    } else if (temp.roles[0].englishTitle == 'User115') {
                      this.userRoleEnglishTitle = temp.roles[0].englishTitle;
                      this.userRoleIdForLogin = temp.roles[0].id;
                      let id = temp.roles[0].id.toString();
                      let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
                      localStorage.setItem('dash', encryptId);
                      this.$router.push({ name: 'mission115' });
                    } else if (temp.roles[0].englishTitle == 'User800') {
                      this.userRoleEnglishTitle = temp.roles[0].englishTitle;
                      this.userRoleIdForLogin = temp.roles[0].id;
                      let id = this.userRoleIdForLogin.toString();
                      let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
                      localStorage.setItem('dash', encryptId);
                      this.setTheme('red');
                      this.loadFromLocalStorage_selectStateMission()
                      // this.$router.push({ name: 'dispatchMap' });
                      // const routeData = this.$router.resolve({
                      //   name: 'mission800',
                      // });
                      // window.open(routeData.href, '_blank');
                    } else if (temp.roles[0].englishTitle == 'Admission') {
                      this.userRoleEnglishTitle = temp.roles[0].englishTitle;
                      this.userRoleIdForLogin = temp.roles[0].id;
                      let id = temp.roles[0].id.toString();
                      let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
                      localStorage.setItem('dash', encryptId);
                      this.setTheme('red');
                      this.$router.push({ name: 'admissionMap' });
                      // const routeData = this.$router.resolve({
                      //   name: 'dashboardAdmission',
                      // });
                      const routeData = this.$router.resolve({
                        name: 'admissionMissions',
                      });
                      window.open(routeData.href, '_blank');
                    } else if (temp.roles[0].englishTitle == 'FollowUp') {
                      this.userRoleEnglishTitle = temp.roles[0].englishTitle;
                      this.userRoleIdForLogin = temp.roles[0].id;
                      let id = temp.roles[0].id.toString();
                      let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
                      localStorage.setItem('dash', encryptId);
                      this.setTheme('red');
                      this.$router.push({ name: 'dashboardFollowUp' });
                    } else if (temp.roles[0].englishTitle == 'Doctor') {
                      this.userRoleEnglishTitle = temp.roles[0].englishTitle;
                      this.userRoleIdForLogin = temp.roles[0].id;
                      let id = temp.roles[0].id.toString();
                      let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
                      localStorage.setItem('dash', encryptId);
                      this.setTheme('red');
                      this.$router.push({ name: 'doctorDashboard' });
                    } else if (temp.roles[0].englishTitle == 'Hospital') {
                      this.userRoleEnglishTitle = temp.roles[0].englishTitle;
                      this.userRoleIdForLogin = temp.roles[0].id;
                      let id = temp.roles[0].id.toString();
                      let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
                      localStorage.setItem('dash', encryptId);
                      this.setTheme('red');
                      this.$router.push({ name: 'hospitalMissions' });
                    } else if (temp.roles[0].englishTitle == 'QC') {
                      this.userRoleEnglishTitle = temp.roles[0].englishTitle;
                      this.userRoleIdForLogin = temp.roles[0].id;
                      let id = temp.roles[0].id.toString();
                      let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
                      localStorage.setItem('dash', encryptId);
                      this.setTheme('red');
                      this.$router.push({ name: 'qcDashboard' });
                    } else if (temp.roles[0].id === 11) {
                      this.userRoleEnglishTitle = temp.roles[0].englishTitle;
                      this.userRoleIdForLogin = temp.roles[0].id;
                      let id = temp.roles[0].id.toString();
                      let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
                      localStorage.setItem('dash', encryptId);
                      this.setTheme('red');
                      this.$router.push({ name: 'amarDashboard' });
                    } else if (temp.roles[0].englishTitle == 'OtherOrganization') {
                      this.userRoleEnglishTitle = temp.roles[0].englishTitle;
                      this.userRoleIdForLogin = temp.roles[0].id;
                      let id = temp.roles[0].id.toString();
                      let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
                      localStorage.setItem('dash', encryptId);
                      this.setTheme('red');
                      this.$router.push({ name: 'otherOrganizationMissions' });
                    } else if (temp.roles[0].englishTitle == 'EOC') {
                      this.userRoleEnglishTitle = temp.roles[0].englishTitle;
                      this.userRoleIdForLogin = temp.roles[0].id;
                      let id = this.userRoleIdForLogin.toString();
                      let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
                      localStorage.setItem('dash', encryptId);
                      this.setTheme('red');
                      this.$router.push({ name: 'currentMissionEoc' });
                      // const routeData = this.$router.resolve({
                      //   name: 'currentMissionEoc',
                      // });
                      // window.open(routeData.href, '_blank');
                    } else if (temp.roles[0].englishTitle == 'Dashboard') {
                      this.userRoleEnglishTitle = temp.roles[0].englishTitle;
                      this.userRoleIdForLogin = temp.roles[0].id;
                      let id = this.userRoleIdForLogin.toString();
                      let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
                      localStorage.setItem('dash', encryptId);
                      this.setTheme('red');
                      this.$router.push({ name: 'dashboards_115' });
                    }
                  } else if (temp.roles.length > 1) {
                    let id = '1';
                    let encryptId = CryptoJS.AES.encrypt(id, 'w87ut12BGF0214dAS').toString();
                    this.$router.push({
                      name: 'module',
                      params: { id: encryptId },
                    });
                  } else {
                    this.snackText = this.$store.state.loginModule.error;
                    this.$refs.snackRef.snackModel = true;
                    this.snackColor = '#FF5252';
                    this.snakIcon = 'mdi-information';
                  }
                }
              });
            }
          });
        } else {
          this.wrongLogin = true;
          this.reloadSecurityCode();
          if (this.load.val) {
            this.load.val = false;
          }
          this.snackText = this.$store.state.loginModule.error;
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
        }
      });
    },
    loginUserWithCaptcha: function () {
      if (!this.userLogin.userName) {
        this.snackText = 'لطفا نام کاربری را وارد نمایید';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.userLogin.password) {
        this.snackText = 'لطفا کلمه عبور را وارد نمایید';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.loginCaptcha) {
        this.snackText = 'لطفا کد امنیتی را وارد نمایید';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (this.loginCaptcha < 5) {
        this.snackText = 'لطفا کد امنیتی را صحیح وارد نمایید';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.userLogin.captchaIdentifier = this.captchaIdentifier;
      this.userLogin.captchaCode = this.loginCaptcha;
      this.$store.dispatch('loginUserWithCaptcha', this.userLogin).then(() => {
        if (this.$store.state.loginModule.successFlag) {
          /*if (this.load.val) {
                        this.load.val = false;
                    }*/
          this.$store.dispatch('csrf').then(() => {
            if (this.$store.state.loginModule.successFlag) {
              this.$store.dispatch('getUserCurrent').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  if (this.load.val) {
                    this.load.val = false;
                  }
                  this.userLogin = new User('', '', '');
                  let temp = this.$store.state.userModule.user;
                  if (temp.roles.length === 1) {
                    if (temp.roles[0].englishTitle == 'Admin') {
                      this.userRoleEnglishTitle = temp.roles[0].englishTitle;
                      this.userRoleIdForLogin = temp.roles[0].id;
                      this.$router.push({ name: 'user' });
                      let id = temp.roles[0].id.toString();
                      let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
                      localStorage.setItem('dash', encryptId);
                      this.setTheme('blue');
                    } else if (temp.roles[0].englishTitle == 'User115') {
                      this.userRoleEnglishTitle = temp.roles[0].englishTitle;
                      this.userRoleIdForLogin = temp.roles[0].id;
                      let id = temp.roles[0].id.toString();
                      let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
                      localStorage.setItem('dash', encryptId);
                      this.$router.push({ name: 'mission115' });
                    } else if (temp.roles[0].englishTitle == 'User800') {
                      this.userRoleEnglishTitle = temp.roles[0].englishTitle;
                      this.userRoleIdForLogin = temp.roles[0].id;
                      let id = this.userRoleIdForLogin.toString();
                      let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
                      localStorage.setItem('dash', encryptId);
                      this.setTheme('red');
                      this.loadFromLocalStorage_selectStateMission()
                      // this.$router.push({ name: 'dispatchMap' });
                      // const routeData = this.$router.resolve({
                      //   name: 'mission800',
                      // });
                      // window.open(routeData.href, '_blank');
                    } else if (temp.roles[0].englishTitle == 'Admission') {
                      this.userRoleEnglishTitle = temp.roles[0].englishTitle;
                      this.userRoleIdForLogin = temp.roles[0].id;
                      let id = temp.roles[0].id.toString();
                      let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
                      localStorage.setItem('dash', encryptId);
                      this.setTheme('red');
                      this.$router.push({ name: 'admissionMap' });
                      // const routeData = this.$router.resolve({
                      //   name: 'dashboardAdmission',
                      // });
                      const routeData = this.$router.resolve({
                        name: 'admissionMissions',
                      });
                      window.open(routeData.href, '_blank');
                    } else if (temp.roles[0].englishTitle == 'FollowUp') {
                      this.userRoleEnglishTitle = temp.roles[0].englishTitle;
                      this.userRoleIdForLogin = temp.roles[0].id;
                      let id = temp.roles[0].id.toString();
                      let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
                      localStorage.setItem('dash', encryptId);
                      this.setTheme('red');
                      this.$router.push({ name: 'dashboardFollowUp' });
                    } else if (temp.roles[0].englishTitle == 'Doctor') {
                      this.userRoleEnglishTitle = temp.roles[0].englishTitle;
                      this.userRoleIdForLogin = temp.roles[0].id;
                      let id = temp.roles[0].id.toString();
                      let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
                      localStorage.setItem('dash', encryptId);
                      this.setTheme('red');
                      this.$router.push({ name: 'doctorDashboard' });
                    } else if (temp.roles[0].englishTitle == 'Hospital') {
                      this.userRoleEnglishTitle = temp.roles[0].englishTitle;
                      this.userRoleIdForLogin = temp.roles[0].id;
                      let id = temp.roles[0].id;
                      let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
                      localStorage.setItem('dash', encryptId);
                      this.setTheme('red');
                      this.$router.push({ name: 'hospitalMissions' });
                    } else if (temp.roles[0].englishTitle == 'QC') {
                      this.userRoleEnglishTitle = temp.roles[0].englishTitle;
                      this.userRoleIdForLogin = temp.roles[0].id;
                      let id = temp.roles[0].id.toString();
                      let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
                      localStorage.setItem('dash', encryptId);
                      this.setTheme('red');
                      this.$router.push({ name: 'qcDashboard' });
                    } else if (temp.roles[0].englishTitle == 'statistic') {
                      this.userRoleEnglishTitle = temp.roles[0].englishTitle;
                      this.userRoleIdForLogin = temp.roles[0].id;
                      let id = temp.roles[0].id.toString();
                      let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
                      localStorage.setItem('dash', encryptId);
                      this.setTheme('red');
                      this.$router.push({ name: 'amarDashboard' });
                    } else if (temp.roles[0].englishTitle == 'OtherOrganization') {
                      this.userRoleEnglishTitle = temp.roles[0].englishTitle;
                      this.userRoleIdForLogin = temp.roles[0].id;
                      let id = temp.roles[0].id.toString();
                      let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
                      localStorage.setItem('dash', encryptId);
                      this.setTheme('red');
                      this.$router.push({ name: 'otherOrganizationMissions' });
                    } else if (temp.roles[0].englishTitle == 'EOC') {
                      this.userRoleEnglishTitle = temp.roles[0].englishTitle;
                      this.userRoleIdForLogin = temp.roles[0].id;
                      let id = this.userRoleIdForLogin.toString();
                      let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
                      localStorage.setItem('dash', encryptId);
                      this.setTheme('red');
                      this.$router.push({ name: 'currentMissionEoc' });
                      // const routeData = this.$router.resolve({
                      //   name: 'currentMissionEoc',
                      // });
                      // window.open(routeData.href, '_blank');
                    } else if (temp.roles[0].englishTitle == 'Dashboard') {
                      this.userRoleEnglishTitle = temp.roles[0].englishTitle;
                      this.userRoleIdForLogin = temp.roles[0].id;
                      let id = this.userRoleIdForLogin.toString();
                      let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
                      localStorage.setItem('dash', encryptId);
                      this.setTheme('red');
                      this.$router.push({ name: 'dashboards_115' });
                    }
                  } else if (temp.roles.length > 1) {
                    let id = '1';
                    let encryptId = CryptoJS.AES.encrypt(id, 'w87ut12BGF0214dAS').toString();
                    this.$router.push({
                      name: 'module',
                      params: { id: encryptId },
                    });
                  } else {
                    this.snackText = this.$store.state.loginModule.error;
                    this.$refs.snackRef.snackModel = true;
                    this.snackColor = '#FF5252';
                    this.snakIcon = 'mdi-information';
                  }
                }
              });
            }
          });
        } else {
          this.wrongLogin = true;
          this.reloadSecurityCode();
          if (this.load.val) {
            this.load.val = false;
          }
          this.snackText = this.$store.state.loginModule.error;
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
        }
      });
    },
    sendPhoneNumberForgetPassword: function () {
      if (!this.forgetPasswordPhoneNumer) {
        this.snackText = 'لطفا شماره همراه را وارد نمایید';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (this.forgetPasswordPhoneNumer.length < 11) {
        this.snackText = 'شماره همراه معتبر نیست.';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
    },
  },
};
